import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueCompositionAPI from "@vue/composition-api";
import CustomerWidget from "./views/customerWidget.vue";

Vue.use(ElementUI);
Vue.use(VueCompositionAPI);
Vue.config.productionTip = false;

// iframe 透明背景，叠加在企业站上不可见
document.documentElement.style.background = "transparent";
document.body.style.background = "transparent";

new Vue({
  render: (h) => h(CustomerWidget),
}).$mount("#app");
